import { searchedChemicalsElementsOfCurrentMapSelector } from '@/redux/chemicals/chemicals.selectors';
import { searchedDrugsElementsOfCurrentMapSelector } from '@/redux/drugs/drugs.selectors';
import { markersDataOfCurrentMapSelector } from '@/redux/markers/markers.selectors';
import { store } from '@/redux/store';
import { searchedModelElementsForCurrentModelSelector } from '@/redux/modelElements/modelElements.selector';
import { GetShownElementsPluginMethodResult } from '@/services/pluginsManager/pluginsManager.types';
import { toPluginModelElement } from '@/services/pluginsManager/adapters/toPluginModelElement';

export const getShownElements = (): GetShownElementsPluginMethodResult => {
  const { getState } = store;

  const content = searchedModelElementsForCurrentModelSelector(getState());
  const chemicals = searchedChemicalsElementsOfCurrentMapSelector(getState());
  const drugs = searchedDrugsElementsOfCurrentMapSelector(getState());
  const markers = markersDataOfCurrentMapSelector(getState());

  return {
    content: content.map(toPluginModelElement),
    chemicals: chemicals.map(toPluginModelElement),
    drugs: drugs.map(toPluginModelElement),
    markers,
  };
};
